import * as colors from '../../shared/styles/colors';

export const defaultTheme = {
  menuBackground: colors.blueGrey,
  menuTextColor: colors.backgroundWhite,
  menuButtonBackground: colors.darkGrey,
  menuButtonMidBackground: colors.darkGrey,
  menuButtonOpenedBackground: colors.backgroundWhite,
};
